import { Text, SpinnerWheel } from '@loadsmart/miranda-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSettings } from "@loadsmart/react-frontend-settings";
import LsLogo from 'assets/images/ls_logo.png'

import {
  StyledBackground,
  StyledButtonContainer,
  StyledLoginButton,
  StyledLSLogo,
  StyledTextButtonContainer,
  StyledSigningInContainer
} from './HomePage.styles';
import { LocalStorageClient } from "core/infra/storage/LocalStorageClient";

const storage = new LocalStorageClient();

const HomePage = () => {
  const { isLoading, values } = useSettings([
    "flags.ENABLE_LOGIN_THROUGH_BIP",
    "flags.ENABLE_LOGIN_THROUGH_OPENDOCK"
  ]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [signingIn, setSigningIn] = useState<string | null>(null); // State to track the signing-in process

  const [isLoginThroughBIPEnabled, isOpenDockLoginEnabled] = values

  console.log('[HomePage] Raw feature flags received:', {
    isLoading,
    rawValues: values,
    rawValuesType: typeof values,
    rawBIPFlag: isLoginThroughBIPEnabled,
    rawBIPFlagType: typeof isLoginThroughBIPEnabled,
    rawOpenDockFlag: isOpenDockLoginEnabled,
    rawOpenDockFlagType: typeof isOpenDockLoginEnabled,
  })

  const isBIPEnabled = Boolean(isLoginThroughBIPEnabled)
  const isOpenDockEnabled = Boolean(isOpenDockLoginEnabled)

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    const isMobile = /Mobi/i.test(userAgent);

    if (isMobile) {
      navigate('/mobile-not-supported');
    }

    // Don't clear localStorage if this is an OpenDock redirect
    // The OpenDock auth handler will manage tokens in this case
    const opendockAuth = searchParams.get('opendock_auth');
    const isOpendockAuth = opendockAuth && opendockAuth !== 'true'; // Check if it's a real token, not just "true"
    
    if (!isOpendockAuth) {
      storage.clear();
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    if (signingIn) {
      // Redirect after 3 seconds
      const redirectTimeout = setTimeout(() => {
        if (signingIn === 'bip') {
          navigate('/login');
        } else if (signingIn === 'default') {
          navigate('/login-lmt');
        } else if (signingIn === 'opendock') {
          navigate('/login-opendock');
        }
      }, 3000);

      // Cleanup timeout on unmount
      return () => clearTimeout(redirectTimeout);
    }
  }, [signingIn, navigate]);

  // If signingIn is in progress, show the white background with message
  if (signingIn) {
    return (
      <StyledSigningInContainer>
        <SpinnerWheel size="sm" />
        <Text color="color-text-primary" variant="body-lg-bold">
         Signing in {signingIn === 'bip' ? 'As Shipper Guide' : signingIn === 'opendock' ? 'As OpenDock' : ''}...
        </Text>
      </StyledSigningInContainer>
    );
  }

  return isLoading ? null :(
    <StyledBackground className="full-screen">
      <StyledTextButtonContainer>
        <Text color="color-background-primary" variant="hero-md-bold">
          Take your data analysis to the next level
        </Text>
        {isBIPEnabled ? (
          <StyledButtonContainer>
            <StyledLoginButton
              variant="primary"
              onClick={() => setSigningIn('default')}
            >
              SIGN IN
            </StyledLoginButton>
            <StyledLoginButton
              variant="primary"
              onClick={() => setSigningIn('bip')}
            >
              SIGN IN AS SHIPPER GUIDE
            </StyledLoginButton>
            {isOpenDockEnabled ? (
              <StyledLoginButton
                variant="primary"
                onClick={() => setSigningIn('opendock')}
              >
                SIGN IN AS OPENDOCK
              </StyledLoginButton>
            ) : null}
          </StyledButtonContainer>
        ) : (
          <StyledButtonContainer>
            <StyledLoginButton variant="primary" href="/login">
              SIGN IN
            </StyledLoginButton>
            {isOpenDockEnabled ? (
              <StyledLoginButton variant="primary" href="/login-opendock">
                SIGN IN AS OPENDOCK
              </StyledLoginButton>
            ) : null}
          </StyledButtonContainer>
        )}
      </StyledTextButtonContainer>
      <StyledLSLogo src={LsLogo} alt="LS Logo" />
    </StyledBackground>
  );
};

export default HomePage;
